import styled from 'styled-components';

export default styled.div`
  display: grid;
  grid-template-columns: 140px auto auto;
  grid-template-areas: 'date ip_address user';
  grid-column-gap: 0.5rem;
`;
